<template>
    <MainContent title="Crear equipo">
        <Card>
            <FormEquipo
                :lista-id="listaId"
                :saving="saving"
                :representantes="representantes"
                :representantes-loading="loading"
                @terminado="crearEquipo"
            />
        </Card>
    </MainContent>
</template>

<script setup>
    import { computed, ref, onMounted } from 'vue';
    import { useRoute, useRouter } from '@/composables/common/router/useRouter';
    import { useToast } from '@/composables/common/useToast';
    import store from '@/store';
    import { config } from '@/config.js';
    import MainContent from '@/modules/admin/ui/MainContent.vue';
    import Card from '@/modules/admin/ui/Card.vue';
    import FormEquipo from '@/modules/admin/bases/equipos/components/FormEquipo.vue';

    const route = useRoute();
    const router = useRouter();
    const toast = useToast();
    const saving = ref(false);
    const loading = ref(true);
    const representantes = ref([]);

    const listaId = computed(() => route.params.lista_id);
    const teatro = computed(() => store.getters.getTeatro);

    onMounted(async() => {
        try {
            const params = { lista_id: listaId.value, filters: {} };
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.get.representantes'),
                params
            );
            representantes.value = res.data.representantes || [];
        } catch (error) {
            toast.error('Error al cargar los representantes');
        } finally {
            loading.value = false;
        }
    });

    async function crearEquipo(formData) {
        saving.value = true;

        const payload = {
            ...formData,
            filters: {},
            lista_id: listaId.value,
            teatro_id: teatro.value?.id
        };

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.equipos.crear'),
                payload
            );
            toast.success(res.data.message);
            router.push({ name: 'back.bases.equipos', params: { lista_id: listaId.value } });
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error al crear el equipo');
        } finally {
            saving.value = false;
        }
    }
</script>
